module.exports = "./img/eba176118aa77b38f1cbba218b76f8e6.jpg";